import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@fortawesome/fontawesome-free/js/all.min';
import AppRoute from "./router/AppRoute";
import 'antd/dist/antd.css';
// import httpclient from './components/httpclient';
import './components/axios/interceptor.js'

function App() {
    return (
        <AppRoute />
    );
}

export default App;